import React from 'react'

import { colors } from '@factorialco/deprecated-design-system'

import { BarPositions, ComboChartData } from '../types'

interface TickProps {
  y: number
  value: string
  index: number
  serieId: string
  barPositions: BarPositions
  chartData: ComboChartData[]
  bars: { id: string; color?: string }[]
  lines: { id: string; color?: string }[]
  formatTick?: (label: string, index: number, serieId?: string) => string
}

export const Tick: React.FC<TickProps> = ({
  y,
  bars,
  lines,
  value,
  index,
  serieId,
  chartData,
  formatTick,
  barPositions,
}) => {
  const label = formatTick ? formatTick(value, index, serieId) : `${value} ${serieId}`

  const hasBar = bars.some(({ id: barId }) => {
    return chartData.some(({ id: dataId, data }) => {
      return barId === dataId && data.some(({ x }) => x === value)
    })
  })

  const hasLine = lines.some(({ id: lineId }) => {
    return chartData.some(({ id: dataId, data }) => {
      return lineId === dataId && data.some(({ x }) => x === value)
    })
  })

  if (bars.length === 0) return <></>
  if (!(hasBar || hasLine)) return <></>

  const barId = bars.find(({ id }) => barPositions?.[`${serieId}-${id}`])?.id
  const positions = barPositions?.[`${serieId}-${barId}`]
  const position = positions?.[index]

  if (!position) return <></>

  const xPos = position.x + position.width / 2.0

  return (
    <text
      y={y}
      x={xPos}
      fontSize={12}
      textAnchor="end"
      fill={colors.grey800}
      dominantBaseline="hanging"
      key={`${serieId}-${value}`}
      transform={`rotate(-45, ${xPos}, ${y})`}
    >
      {label}
    </text>
  )
}
